import React, {useImperativeHandle, useRef} from 'react';
import {classes, style} from './modal-view.st.css';
import {IHostingModalController} from './modals-scope';
import {IInnerWindowClosingController, RenderFunction} from '../index';
import {assertNotNullable, Evaluable, evaluateWhenFunction} from '@wix/devzai-utils-common';
import {reactCreateMemo} from "../react-utils/react-utils";

export const ModalView = reactCreateMemo(React.forwardRef((props: ModalView.Props, ref: React.Ref<ModalView>) => {
    const {
        overlay,
        content,
        zIndex,
        modalController,
        overlayWindowClosingControllerRef,
        contentWindowClosingControllerRef
    } = props;

    const rootRef = useRef<HTMLDivElement>(null);

    useImperativeHandle(ref, () => {
        return {
            getBodyElement() {
                return assertNotNullable(rootRef.current?.lastElementChild);
            }
        }
    });

    return (
        <div
            ref={rootRef}
            className={style(classes.root, props.className)}
            style={{
                zIndex: zIndex
            }}
        >
            {evaluateWhenFunction(overlay, {
                modalController: modalController,
                innerWindowClosingControllerRef: overlayWindowClosingControllerRef
            })}
            {evaluateWhenFunction(content, {
                modalController: modalController,
                innerWindowClosingControllerRef: contentWindowClosingControllerRef
            })}
        </div>
    );
}));

export interface ModalView {
    getBodyElement () : Element;
}


export namespace ModalView {

    export interface PartRenderProps {
        modalController: IHostingModalController;
        innerWindowClosingControllerRef: React.Ref<IInnerWindowClosingController>;
    }

    export type PartRenderFunction = RenderFunction<PartRenderProps, React.ReactElement>;

    export interface Props {
        content: Evaluable<PartRenderFunction>;
        overlay?: Evaluable<PartRenderFunction>;
        zIndex?: number;
        className?: string;
        modalController: IHostingModalController;
        overlayWindowClosingControllerRef: React.RefObject<IInnerWindowClosingController>;
        contentWindowClosingControllerRef: React.RefObject<IInnerWindowClosingController>;
    }
}